import type { Move } from '../../../schemas/move';

/**
 * ***Apprendista Multiclasse*** — mossa comune disponibile **oltre il
 * 10° livello** per PG Apprendista/Instancabile (manuale V1 r. 1793-1797).
 *
 * Effetto: scegli una mossa **iniziale** di un'altra classe. Non prendere
 * mosse multiclasse.
 *
 * Strutturazione (D10 / FI-11):
 *  - `type: 'common'` (no classId, mossa cross-classe)
 *  - `multiclass.picks.kind: 'any-other-class'` (qualsiasi altra classe)
 *  - `multiclass.levelAdjustment.delta: -9` (PG Instancabile è L10 effettivo
 *    cappato; con `-9` il livello effettivo per scegliere la mossa-target
 *    diventa L1 → solo mosse `starting`)
 *  - Vincolo «Non prendere mosse multiclasse» enforced nativamente dal
 *    service FI-17 (filtro `tags: ['multiclasse']` sul pool).
 *
 * Catena prerequisiti (D10 / FI-11):
 *  - Apprendista (entry point, no prereq)
 *  - Adepto → req Apprendista
 *  - Esperto → req Adepto
 *  - Maestro → req Esperto
 *  - Gran Maestro → req Maestro
 *
 * Disponibilità: filtrata dal predicate `isCommonMoveAvailable` di
 * `services/commonMovesAvailability.ts` se
 * `character.pastTen ∈ {'apprendista', 'instancabile'}`.
 */
export const apprendistaMulticlasse: Move = {
  id: 'common.apprendista-multiclasse',
  name: 'Apprendista Multiclasse',
  type: 'common',
  trigger: 'Quando prendi questa mossa al level-up (oltre il 10° livello)',
  description: "Scegli una mossa iniziale di un'altra classe. Non prendere mosse multiclasse.",
  tags: ['multiclasse'],
  prerequisites: [],
  replaces: [],
  multiclass: {
    picks: { kind: 'any-other-class' },
    // -9: PG Instancabile è L10 effettivo cappato → mosse-target di livello
    // effettivo 1 (solo starting).
    levelAdjustment: { delta: -9 },
  },
};
